import Factory from '../factory';

const schema = Factory.schema('page-adverts');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String).setValue('Panel title');
attributes.prop('summary').setType(String).setValue('This is a panel');
attributes.prop('variant').setType(String).setValue('alpha');
attributes.prop('items').setType(Array);

export default schema;
